import * as React from 'react';
import * as Models from '../../../models/index';
import classnames from 'classnames';
import * as Components from '../../../components/index';
export interface MessageListProps {
	messages: Models.CorporateMessage[];
	selected: Models.CorporateMessage;
	onSelect: (message: any) => any;
	onChange?: (message: any) => any;
}
export default class MessageList extends React.PureComponent<MessageListProps> {
	render() {
		return (
			<Components.LayoutBlock fill className='message-list' scrollable>
				{this.props.messages.map((message, index) => (
					<MessageListItem key={index} message={message} isSelected={message === this.props.selected} />
				))}
			</Components.LayoutBlock>
		);
	}
}

export interface MessageListItemProps {
	message: Models.CorporateMessage;
	isSelected?: boolean;
}
export const MessageListItem: React.StatelessComponent<MessageListItemProps> = props => (
	<Components.LayoutBlock
		className={classnames('message-list-item', {
			'message-list-item-selected': props.isSelected,
		})}
		inline
		verticalAlign='center'
	>
		<Components.Icon icon='message' size='2' color='white' />
		{props.message.subject}
	</Components.LayoutBlock>
);
